import React, { useCallback } from 'react';
import { Container, Row, Col } from 'reactstrap';
import moment from 'moment';
import { Link } from 'react-router-dom';

import {
  AsyncTableInfinite, Intl, TableSelectFilter,
} from 'components';
import { formatNumeral, isCustomerAdmin } from 'utils';

export default ( {
  data,
  parentPath,
  isLoading,
  participants,
  participantsLoading,
  userRoles,
  onFetchData,
  userData,
} ) => {
  const status = useCallback( ( campaignStatus ) => {
    switch ( campaignStatus ) {
      case 'stopped':
      case 'cancelled':
      case 'finished':
        return campaignStatus;
      case 'pending':
      case 'execution':
        return 'execution';
      default:
        return 'scheduled';
    }
  }, [] );

  return (
    <>
      <Container fluid className="mt-3">
        <AsyncTableInfinite
          data={data.data}
          total={data.total}
          isLoading={isLoading}
          defaultSortBy={[{ id: 'createdAt', desc: true }]}
          onFetchData={onFetchData}
          intervalCall
          // titleContent={<Intl id="campaigns" />}
          tableName="campaigns"
          fullHeader
          customFilters={( { filters, setFilter } ) => (
            <>
              {isCustomerAdmin( userRoles ) && (
                <Row className="justify-content-center">
                  <Col lg={3} md={5} sm={8} xs={12} className="pt-1 pt-lg-0">
                    <TableSelectFilter
                      name="createdBy"
                      placeholder="selectUser"
                      filters={filters}
                      isClearable
                      setFilter={setFilter}
                      options={participants}
                      isLoading={participantsLoading}
                    />
                  </Col>
                </Row>
              )}
            </>
          )}
          columns={[
            {
              Header: 'campaign',
              accessor: 'name',
              width: 36,
            },
            {
              Header: 'user',
              accessor: 'createdBy',
              width: 20,
              Cell: ( { cell } ) => ( cell.value
                ? `${cell.value.firstName || ''} ${cell.value.lastName || ''}`
                : '' ),
            },
            {
              Header: 'requestedStart',
              accessor: 'startDateTimeUtc',
              Cell: ( { cell } ) => (
                <span>
                  {moment
                    .tz(
                      moment( Number( cell.value ) ),
                      'YYYY-MM-DD HH:mm',
                      true,
                      cell.row.original.timeZone,
                    )
                    .format( 'YYYY-MM-DD HH:mm' )}
                  <br />
                  {cell.row.original.timeZone}
                </span>
              ),
              width: 15,
            },
            {
              Header: 'costCurrency',
              accessor: 'cost',
              Cell: ( { cell } ) => formatNumeral( cell.value ),
              width: 10,
            },
            {
              Header: 'status',
              accessor: 'status',
              width: 10,
              Cell: ( { cell } ) => ( cell.value ? <Intl id={status( cell.value )} /> : '' ),
            },
            {
              accessor: 'id',
              disableSorting: true,
              width: 10,
              Header: '',
              Cell: ( { cell } ) => (
                <Link
                  to={`${parentPath}/${cell.row.original.id}`}
                  className="text-mp-blue-1"
                >
                  <Intl id="details" />
                </Link>
              ),
            },
          ]}
          minHeight
          values={{ currency: "(" + userData.currency_symbol + ")" }}
          headerWidth={['col-4', 'col', 'col', 'col-1-1qtr', 'col', 'col']}
          minRows={14}
        />
      </Container>
    </>
  );
};
